// noinspection JSUnusedGlobalSymbols

import * as Apollo from '@apollo/client';

import { gql } from '@apollo/client';
import type * as Types from '../../__generated__/types';

const defaultOptions = {} as const;
export type UpdateDivisionMutationVariables = Types.Exact<{
  input: Types.UpdateDivisionInput;
}>;

export type UpdateDivisionMutation = { __typename?: 'Mutation' } & {
  updateDivision: { __typename?: 'DivisionOutput' } & Pick<Types.DivisionOutput, 'id'>;
};

export const UpdateDivisionDocument = /*#__PURE__*/ gql`
    mutation updateDivision($input: UpdateDivisionInput!) {
  updateDivision(input: $input) {
    id
  }
}
    `;
export type UpdateDivisionMutationFn = Apollo.MutationFunction<UpdateDivisionMutation, UpdateDivisionMutationVariables>;

/**
 * __useUpdateDivisionMutation__
 *
 * To run a mutation, you first call `useUpdateDivisionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDivisionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDivisionMutation, { data, loading, error }] = useUpdateDivisionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDivisionMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateDivisionMutation, UpdateDivisionMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateDivisionMutation, UpdateDivisionMutationVariables>(UpdateDivisionDocument, options);
}
export type UpdateDivisionMutationHookResult = ReturnType<typeof useUpdateDivisionMutation>;
export type UpdateDivisionMutationOptions = Apollo.BaseMutationOptions<
  UpdateDivisionMutation,
  UpdateDivisionMutationVariables
>;
